import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import type { CustomFontAwesomeIconProps } from './types/custom-font-awesome-icon.props';

/**
 * Grip vertical icon — used as a drag handle for reorderable rows.
 */
export const GripVertical = (props: CustomFontAwesomeIconProps) => {
  return (
    <FontAwesomeIcon
      icon={['fass', 'grip-vertical']}
      {...props}
    />
  );
};
